// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import * as types from './actionTypes';

export function requestAddressSearch(data) {
  return {
    type: types.ADDRESS_SEARCH_REQUEST,
    data
  };
}
export function addressSearchRequestFailed() {
  return {
    type: types.ADDRESS_SEARCH_REQUEST_FAILED,
  };
}
export function addressSearchRequestSuccess(results) {
  return {
    type: types.ADDRESS_SEARCH_REQUEST_SUCCESS,
    results,
  };
}

export function requestSelectedAddress(data) {
  return {
    type: types.SELECTED_ADDRESS_REQUEST,
    data
  };
}

export function requestSelectedAddressSuccess(result) {
  return {
    type: types.SELECTED_ADDRESS_REQUEST_SUCCESS,
    result,
  };
}
export function requestSelectedAddressFailed() {
  return {
    type: types.SELECTED_ADDRESS_REQUEST_FAILED,
  };
}

export function changeField(value, field) {
  return {
    type: types.ADDRESS_SEARCH_FIELD_CHANGE,
    value,
    field
  };
}

export function resetSearchInput() {
  return {
    type: types.ADDRESS_RESET_SEARCH_INPUT,
  };
}
